import { defineStore } from 'pinia'
import * as api from '@/service/index'
import { useStageStore } from './stage'

const createUserInfo = () => ({
  amount: 0,
  loginReceive: '',
  viewReceive: '',
  viewTime: 0
})

const createState = () => ({
  token: '',
  uid: '',
  amount: 0,
  userInfo: createUserInfo()
})

export const useSessionStore = defineStore('session', {
  state: () => createState(),
  actions: {
    setToken(token = '') {
      this.token = token
    },
    async reqUserInfo(force) {
      if (!this.token) return

      const response = await api.reqUserInfo({ token: this.token, force })
      if (response.status === 200) {
        const info = response.data
        this.userInfo = {
          quizAmounts: info.quizRemainNum,
          matchAmounts: info.matchRemainNum,
          viewTime: info.viewTime,
          ...info
        }
        this.amount = info
        if (info.uid) {
          this.uid = info.uid
        }
        useStageStore().syncEventStage()
      } else {
        // 避免 store 循环依赖 (ui → session), 动态引入 ui store 展示 toast
        const { useUiStore } = await import('./ui')
        useUiStore().showPrompt(response.data)
      }

      return response
    }
  }
})
